import { extendTheme } from 'native-base';

export const liveTTScoreboardTheme = extendTheme({
    colors: {
        primary: {
            50: "white",
            100: "#e4e4e7",
            200: "#a1a1aa",
            300: "#5A82D8",
            400: "#5A82D8",
            500: "#5A82D8",
            600: "#5A82D8",
            700: "#3f3f46",
            800: "#52525b",
            900: "blue",



            actionButton: "#ff1122",
        },

        tt: {
            100: "white",
            closeButton: "",
            actionButton: "#ff1122",
            disabledButton: "gray",
            buttonText: "white"
        }
    },
});
